var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.053,
    height: 26.999,
    viewBox: "0 0 13.053 26.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M13.053,9.281,11.422,13.5H8.158V27H3.263V13.5H0V9.281H3.263V5.062A4.98,4.98,0,0,1,8.158,0h3.263V4.218H9.79A1.661,1.661,0,0,0,8.158,5.906V9.281Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc76eb846c4053bd8ebd74d4a82e9297.svg";
export { ForwardRef as ReactComponent };